module.exports = __webpack_public_path__ + "static/safespace-c43d11b8f18710e80e353f9b622c6e75.png";